import antDirective from '../_util/antDirective';
var base = {};
var install = function install(Vue) {
  base.Vue = Vue;
  Vue.use(antDirective);
};
base.install = install;

export default base;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/base/index.js
// module id = null
// module chunks = 